// Menu structure for sidebar
export const menuStructure = [
  {
    id: "introducere",
    title: "I. Introducere",
  },
  {
    id: "participarea-proces",
    title: "II. Participarea la proces",
    subsections: [
      { id: "nevoi-protectie", title: "Nevoi specifice de protecție" },
      { id: "avocatul", title: "Avocatul" },
      { id: "alte-drepturi", title: "Alte drepturi" },
    ],
  },
];

// Content data for each section
export const contentData = {
  "introducere": {
    title: "Drepturile victimelor infracțiunilor motivate de ură",
    sections: [
      {
        content: "Simplul fapt de a fi victima unei infracțiuni motivate de prejudecată poate fi copleșitor, iar interacțiunea cu un necunoscut, fie el și polițist sau procuror, poate fi dificilă. Destăinuirea celor mai intime detalii personale, riscul răspândirii lor în alte cercuri, posibila împărtășire a prejudecății a cărei victimă a fost persoana de către interlocutor sunt bariere serioase în calea sesizării și atenției acordate explicării propriilor drepturi, acolo unde o procedură a fost inițiată."
      },
      {
        richContent: [
          { text: "Victimele infracțiunilor motivate de ură au aceleași drepturi ca și victimele oricărei infracțiuni. Veți regăsi aceste drepturi în " },
          { text: "Codul de procedură penală", href: "https://legislatie.just.ro/Public/DetaliiDocument/185907", color: "#1565C0" },
          { text: ", dar și în " },
          { text: "Legea nr. 211/2004 privind unele măsuri pentru asigurarea informării, sprijinirii și protecției victimelor infracțiunilor", href: "https://legislatie.just.ro/public/detaliidocument/52468", color: "#1565C0" },
          { text: "." },
        ]
      },
      {
        content: "Astfel:",
        richList: [
          [
            { text: "În situații de " },
            { text: "urgență", bold: true, underline: true },
            { text: ", puteți - și este ferm recomandat - să apelați " },
            { text: "112", bold: true, color: "#e53935", href: "tel:112" },
            { text: "." },
          ],
          "Aveți dreptul să fiți informat despre drepturile dumneavoastră – chiar înainte de a formula plângere. Dacă nu înțelegeți anumite cuvinte, termeni, noțiuni juridice, puteți cere explicații, detalii.",
          "Dacă nu înțelegeți limba română, aveți dreptul la interpret.",
          "Aveți dreptul să fiți ascultat – veți declara versiunea dumneavoastră despre comiterea faptei.",
        ]
      },
    ],
  },
  "participarea-proces": {
    title: "Participarea la proces",
    sections: [
      {
        content: "Dacă vreți să participați în proces ca persoană vătămată, aveți mai multe drepturi și un rol activ în tot ceea ce urmează. Atunci când alegeți să participați în proces ca persoană vătămată, sunteți lăsat să relatați liber evenimentele petrecute, așa cum le-ați perceput, după care polițistul/procurorul vă poate pune întrebări la care va trebui să răspundeți. Aceste întrebări au rolul de a clarifica cele spuse deja de dumneavoastră, inclusiv de a scoate în evidență unele detalii.",
        list: [
          "Atunci când sunteți asistat de un avocat la audiere, aveți dreptul să vă consultați cu acesta în orice moment.",
          "Puteți să vă folosiți de anumite însemnări personale pe care le-ați făcut cu privire la evenimentele despre care oferiți declarația.",
          "Puteți declara că vreți să fiți despăgubit de către infractor pentru impactul negativ pe care fapta acestuia a avut-o (și o are) asupra dumneavoastră.",
          "Veți putea da acum detalii despre urmările negative fizice, emoționale sau financiare pe care infracțiunea le-a avut asupra dumneavoastră.",
          "Detalii despre urmările negative și eventuale despăgubiri solicitate de dumneavoastră vor mai putea fi clarificate și ulterior în proces.",
          "La finalul audierii, veți citi cele scrise pe hârtie ca fiind declarația dumneavoastră și veți semna. Aveți dreptul să cereți ca audierea dumneavoastră să fie înregistrată audio/audio-video.",
          "Vă rugăm să aveți în vedere că la audierea dumneavoastră poate participa și un avocat al persoanei pe care ați reclamat-o.",
          "Dacă procesul ajunge să fie judecat în instanță, atunci veți fi audiat din nou în fața unui judecător, iar aici persoana reclamată sau avocatul acesteia are dreptul să vă adreseze întrebări. Nu va trebui să răspundeți la acestea decât dacă judecătorul vă va cere asta.",
          "Dacă renunțați la posibilitatea de a fi persoană vătămată, atunci polițistul/procurorul va decide dacă vă va audia ca martor în cauză (de obicei, însă, sunteți audiat ca martor într-o astfel de situație).",
        ]
      },
    ],
    subsections: {
      "nevoi-protectie": {
        title: "Nevoi specifice de protecție",
        sections: [
          {
            content: "Dacă a fost stabilită în condițiile legii existența unor nevoi specifice de protecție, organul judiciar dispune una sau mai multe dintre următoarele măsuri cu privire la audierea dumneavoastră:",
            list: [
              "audierea în incinte concepute sau adaptate",
              "audierea prin intermediul sau în prezența unui psiholog sau a altui specialist în consilierea victimelor",
              "audierea, cât şi eventuala reaudiere se realizează de aceeași persoană, dacă acest lucru este posibil şi dacă organul judiciar apreciază că aceasta nu aduce atingere bunei desfășurări a procesului ori drepturilor şi intereselor părților",
              "audierea prin videoconferință sau alte mijloace tehnice de comunicare la locul unde beneficiază de măsura de protecție a cazării temporare",
            ]
          },
        ],
      },
      "avocatul": {
        title: "Avocatul",
        sections: [
          {
            content: "Aveți dreptul să fiți asistat de un avocat ales de dumneavoastră încă înainte de a decide că veți formula plângere.",
            list: [
              "Avocatul vă va oferi sfaturi juridice pentru proces.",
              "Avocatul dumneavoastră poate asista la efectuarea actelor de urmărire penală.",
              "Avocatul dumneavoastră poate participa la ascultarea persoanei bănuite de comiterea faptei.",
              "Prin intermediul avocatului puteți adresa întrebări persoanei bănuite de săvârșirea faptei.",
            ]
          },
        ],
      },
      "alte-drepturi": {
        title: "Alte drepturi",
        sections: [
          {
            richList: [
              "Pe lângă avocat, o persoană de încredere aleasă de dumneavoastră poate să vă însoțească atunci când vă prezentați la organele judiciare. Dumneavoastră decideți dacă aveți nevoie, și cine este această persoană.",
              "În cazul persoanelor cu dizabilități intelectuale sau psihosociale, puteți cere organului judiciar să apeleze la specialiști care sunt pregătiți să vă faciliteze comunicarea cu ele. De regulă, acești specialiști sunt psihologi care au pregătire în acest sens. Ei nu sunt avocați, ci trebuie să adopte o atitudine neutră.",
              "Aveți dreptul să propuneți probe – să cereți organului judiciar să audieze anumite persoane, să ceară părerea unor experți sau specialiști, să ceară anumite date sau înscrisuri.",
              "Aveți dreptul să ridicați excepții și să puneți concluzii – mai ales dacă vă veți afla în fața unui judecător. Excepțiile sunt, în general, aspecte sau incidente care privesc chestiuni de procedură și, mai rar, fondul cauzei.",
              "Vi se poate cere să depuneți concluzii la finalul judecății. Este momentul în care veți prezenta instanței opinia dumneavoastră argumentată despre faptă și alte chestiuni pe care le considerați importante, inclusiv încadrarea juridică dată faptei, obținerea de despăgubiri (cuantumul și felul lor).",
              "Puteți formula alte cereri, în scris.",
              "Aveți dreptul de a fi informat, într-un termen rezonabil, cu privire la stadiul urmăririi penale – puteți indica o adresă de poștă electronică sau de mesagerie electronică la care să vă fie comunicate aceste informații.",
              "Aveți dreptul să studiați dosarul – vi se va comunica un interval de timp în care puteți face acest lucru.",
              "Aveți dreptul să fiți reprezentat – o persoană aleasă de dumneavoastră poate să vă reprezinte în fața organelor judiciare.",
              "Aveți dreptul să apelați la un mediator – pentru a evita un proces judiciar, puteți recurge la o persoană abilitată, numită mediator, care va favoriza stabilirea pe cale amiabilă a felului în care veți fi despăgubit de autorul faptei vătămătoare.",
              {
                content: "Aveți dreptul să fiți despăgubit pentru prejudiciul suferit prin comiterea faptei – daunele pot fi materiale (dacă ați suferit prejudiciu fizic, material) sau morale (dacă ați suferit un prejudiciu psihic).",
                subItems: [
                  "Dacă doriți să fiți despăgubit, veți dobândi calitatea de parte civilă. Puteți deveni parte civilă doar până la începerea cercetării judecătorești (când judecătorul a terminat măsurile premergătoare judecății, părțile sunt citate legal, au fost finalizate alte verificări și lămuriri și inculpatului i s-a citit învinuirea adusă de procuror).",
                ]
              },
              "Aveți dreptul să atacați hotărârile procurorului sau judecătorului, dacă apreciați că acestea sunt netemeinice sau nelegale. Ar fi bine să consultați un avocat, dacă doriți să contestați soluțiile care vă privesc.",
              [
                { text: "Aveți dreptul să vă adresați serviciilor de sprijin organizate la nivelul direcțiilor de asistență socială și protecția copilului. Acestea se numesc servicii pentru sprijinirea victimelor infracțiunilor. Mai multe detalii regăsiți în " },
                { text: "Legea nr. 211/2004", href: "https://legislatie.just.ro/public/detaliidocument/52468", color: "#1565C0" },
                { text: "." },
              ],
            ]
          },
        ],
      },
    },
  },
};
